import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import { Panel } from "primereact/panel";
import {InputText} from "primereact/inputtext";
import {TriStateCheckbox} from "primereact/tristatecheckbox";
import axios from "axios";

const TracklogListComponent = (props) => {

  const {t, view, detailedSearchVisible, onDetailedSearchActiveChange} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [tracklogs, setTracklogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const DS_STORAGE_KEY = 'lastTracklogDetailedSearchForm';
  const LIST_STORAGE_KEY = 'lastTracklogListState';
  const savedListState = localStorage.getItem(LIST_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(LIST_STORAGE_KEY))
    : null;
  const savedDetailedForm = localStorage.getItem(DS_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(DS_STORAGE_KEY))
    : null;
  const [machines, setMachines] = useState([]);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [detailedSearchQuery, setDetailedSearchQuery] = useState(savedListState?.detailedSearchQuery);

  const isDetailedSearchActive = React.useMemo(() => {
    return (detailedSearchQuery || '').toString().trim().length > 0;
  }, [detailedSearchQuery]);
  const [dsEmployeeName, setDsEmployeeName] = useState(savedDetailedForm?.employeeName || '');
  const [dsMachineId, setDsMachineId] = useState(savedDetailedForm?.machineId || null);
  const [dsProjectNumber, setDsProjectNumber] = useState(savedDetailedForm?.projectNumber || '');
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      let extraQuery = '';
      let finalDetailedQuery = detailedSearchQuery;
       if (props.forcedSearchQuery) {
        finalDetailedQuery = finalDetailedQuery 
          ? finalDetailedQuery + (finalDetailedQuery.endsWith('&') || props.forcedSearchQuery.startsWith('&') ? '' : '&') + props.forcedSearchQuery
          : props.forcedSearchQuery;
      }
      if (finalDetailedQuery) {
        if (!query || query.toString().length === 0) {
          query = '?' + finalDetailedQuery;
        } else if (query.toString().includes('?')) {
          query = query + (query.toString().endsWith('?') || query.toString().endsWith('&') ? '' : '&') + finalDetailedQuery;
        } else {
          query = '?' + query + '&' + finalDetailedQuery;
        }
      }
      if (extraQuery) {
        query += (query.endsWith('?') || query.endsWith('&') ? '' : '&') + extraQuery;
      }
      apiCall('get', '/api/v2/track-log' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setTracklogs(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const persistDetailedForm = () => {
    const payload = {
      employeeName: dsEmployeeName,
      machineId: dsMachineId,
      projectNumber: dsProjectNumber,
    }
    localStorage.setItem(DS_STORAGE_KEY, JSON.stringify(payload));
  }

  const clearDetailedFormPersist = () => {
    localStorage.removeItem(DS_STORAGE_KEY);
  };

  const buildDetailedSearchQuery = () => {
    let parts = [];
    const like = (field, val) => {
      const v = (val || '').toString().trim();
      if (!v) return;
      parts.push(`search[${field}][operator]=like&search[${field}][value]=*${encodeURIComponent(v)}*`);
    };
    if (dsMachineId) {
      parts.push(`search[machine][operator]==&search[machine][value]=${dsMachineId}`);
    }
    like('employee_name', dsEmployeeName);
    like('project_number', dsProjectNumber);
    return parts.join('&');
  };

  const doDetailedSearch = () => {
    const q = buildDetailedSearchQuery();
    setDetailedSearchQuery(q);
    setLazyParams((prev) => ({
      ...prev,
      first: 0,
      page: 0,
    }));
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  };

  const getMeasureValue = (rowData) => {
    const type = rowData?.measure?.type;
    if (type === 'datetime' || type === 'date_time' || type === 'date') {
      return rowData?.value_date_time
        ? window.App.formatDateValue(rowData.value_date_time)
        : '-';
    }
    if (type === 'string' || type === 'text') {
      return rowData?.value_string ?? '-';
    }
    if (type === 'decimal' || type === 'float') {
      return rowData?.value_float ?? '-';
    }
    if (type === 'int' || type === 'integer') {
      return rowData?.value_int ?? '-';
    }
    return rowData?.raw_value ?? '-';
  };

  useEffect(() => {
    apiCall('get', '/api/v2/machine?item_per_page=100')
      .then(response => {
        setMachines(response.data?.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      rows: rows
    }));
  }, [rows]);

  useEffect(() => {
      localStorage.setItem(LIST_STORAGE_KEY, JSON.stringify({
      rows,
      lazyParams,
      detailedSearchQuery,
      sortField: lazyParams.sortField,
      sortOrder: typeof lazyParams.sortOrder === 'number' ? lazyParams.sortOrder : -1,
    }));
  }, [rows, lazyParams, detailedSearchQuery]);

  useEffect(() => {
    if (typeof onDetailedSearchActiveChange === 'function') {
      onDetailedSearchActiveChange(isDetailedSearchActive);
    }
  }, [isDetailedSearchActive, onDetailedSearchActiveChange]);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, detailedSearchQuery, window.App.state.rerenderTracklogList]);

  return (
    <>

      {(detailedSearchVisible  || view === 'search') &&
        <Panel className="p-mb-2" onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              doDetailedSearch();
            }
          }}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnEmployee')}</label>
                <InputText value={dsEmployeeName} onChange={(e) => setDsEmployeeName(e.target.value)} />
              </div>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnEquipment')}</label>
                <Dropdown
                  value={dsMachineId}
                  options={machines}
                  optionLabel="name"
                  optionValue="id"
                  onChange={(e) => setDsMachineId(e.value)}
                  showClear
                  filter
                  placeholder={t('dsSelectEquipment')}
                  appendTo={document.body}
                />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('projectNumber')}</label>
                <InputText value={dsProjectNumber} onChange={(e) => setDsProjectNumber(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-text-right"}>
              <Button
                type="button"
                label={t('dsClearCriteria')}
                icon="pi pi-times"
                className="p-button-danger p-mr-2"
                onClick={() => {
                  setDetailedSearchQuery('');
                  setDsProjectNumber('');
                  setDsMachineId(null);
                  setDsEmployeeName('');
                  clearDetailedFormPersist();
                  localStorage.removeItem(LIST_STORAGE_KEY);
                  setLazyParams({
                    first: 0,
                    rows: rows,
                    page: 0,
                    sortField: 'id',
                    sortOrder: 1,
                  });
                }}
              />
              <Button
                type="button"
                label={t('dsSearch')}
                icon="pi pi-search"
                className="p-button-primary"
                onClick={() => {
                  const q = buildDetailedSearchQuery();
                  setDetailedSearchQuery(q);
                  persistDetailedForm();
                  setLazyParams({
                    ...lazyParams,
                    first: 0,
                    page: 0,
                  });
                }}
              />
            </div>
          </div>
        </Panel>
      }
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={tracklogs} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="issue_date" header={t('columnDateAndTime')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.issue_date)}</>
          )
        }}></Column>
        <Column field="production_item.project_number" header={t('projectNumber')} sortable filter></Column>
        <Column field="employee.name" header={t('columnEmployee')} sortable filter></Column>
        <Column field="machine.name" header={t('columnEquipment')} sortable filter></Column>
        <Column field="measure.name" header={t('columnMetric')} sortable filter></Column>
        <Column header={t('columnValue')} sortable filter body={(rowData) => getMeasureValue(rowData)}></Column>
        <Column field="measure.unit.name" header={t('columnUnit2')} sortable filter></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(TracklogListComponent);
